import React from "react";

const NotFound = () => {
  return (
    <div style={styles.container}>
      <div style={styles.message}>404 | Not Found</div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f0f0',
  },
  message: {
    fontSize: '2rem',
    color: '#333',
  }
}

export default NotFound;